import {
  PROTOCOL_CONSTANTS,
  serverMessageSchema,
  type ProtocolEnvelope,
  type ServerMessage,
} from "@klass-share/protocol";
import { WEB_DEPLOYMENT_CONFIG } from "./deployment-config.js";

export type {
  Capabilities,
  DeviceClass,
  JoinAckFailurePayload as JoinFailure,
  JoinAckSuccessPayload as JoinSuccess,
  JoinPayload,
  LegCreatePayload,
  PeerInfo,
  RoomState,
  RtcSignalPayload,
  ShareState,
} from "@klass-share/protocol";

export const CLIENT_ORIGIN = WEB_DEPLOYMENT_CONFIG.shareOrigin;
export const SIGNAL_PORT = PROTOCOL_CONSTANTS.SIGNAL_PORT;
export const PROTOCOL_VERSION = PROTOCOL_CONSTANTS.PROTO_VERSION_MAX;
export const HEARTBEAT_FALLBACK_MS = PROTOCOL_CONSTANTS.T_HB_INTERVAL;
export const HIDDEN_PONG_TOLERANCE_MS =
  PROTOCOL_CONSTANTS.T_HIDDEN_PONG_TOLERANCE;
export const RECONNECT_BASE_MS = PROTOCOL_CONSTANTS.WS_BACKOFF_BASE;
export const RECONNECT_CAP_MS = PROTOCOL_CONSTANTS.WS_BACKOFF_CAP;
export const DISC_GRACE_MS = PROTOCOL_CONSTANTS.T_DISC_GRACE;

/** Normative UX threshold in SPEC v1.3 section 8.2 (not a section 10 protocol timer). */
export const RECONNECT_ESCALATION_MS = 2 * 60_000;

export type Envelope = ProtocolEnvelope;

export interface StatsSnapshot {
  legId: string;
  state: RTCIceConnectionState;
  candidatePairType: string;
  rttMs: number;
  bytesReceived: number;
  framesDecoded: number;
  freezeCount: number;
  codec?: string;
  codecFmtp?: string;
}

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

/** Runtime validation uses the normative protocol schema and its additive-field policy. */
export function parseServerMessage(raw: string): ServerMessage | undefined {
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return undefined;
  }
  const result = serverMessageSchema.safeParse(parsed);
  return result.success ? result.data : undefined;
}

export function payloadRecord(message: ServerMessage): Record<string, unknown> {
  return isRecord(message.payload) ? message.payload : {};
}
